import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DictsType } from 'Modules'

export type DictsState = {
	all: DictsType
}

const initialState: DictsState = {
	all: null,
}

export namespace DictsNS {
	export type GetAll = PayloadAction
	export type SetAll = PayloadAction<DictsType>
}

export const dictsSlice = createSlice({
	name: 'dicts',
	initialState,
	reducers: {
		getAll: (state, action: DictsNS.GetAll) => {},
		setAll: (state, action: DictsNS.SetAll) => {
			state.all = action.payload
		},
	},
})
